import { render, staticRenderFns } from "./Flag.vue?vue&type=template&id=5d011d14&scoped=true&"
import script from "./Flag.vue?vue&type=script&lang=ts&"
export * from "./Flag.vue?vue&type=script&lang=ts&"
import style0 from "./Flag.vue?vue&type=style&index=0&id=5d011d14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d011d14",
  null
  
)

export default component.exports